import _SearchPageContainer from './SearchPageContainer'

export const SearchPageContainer = _SearchPageContainer

export default { SearchPageContainer }
